module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/fallback_380_380_5cc54e4.png";